<template lang="html">
  <div class="box-wrap"  :class="{'box-wrap-min': min }">
    <div class="name">{{name}}</div>
    <div class="box">
      <img >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    min: {
      type: Boolean,
      default: false
    }
  },
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  }
}

</script>
 
<style lang="stylus" scoped>
.box-wrap {
  width: 100%;
  height: 100%;
  background: url('../../../../../../assets/img/common/ljcborder.png');
  background-size: 100% 100%;
}

.box-wrap-min {
  width: 100%;
  height: 100%;
  background: url('../../../../../../assets/img/common/ljcborder.png');
  background-size: 100% 100%;
}

.box {
  width: 100%;
  margin-left: 0.5vh;
}

.name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 16px;
  padding-top: 13px;

  &:before {
    display: block;
    content: '';
    background: url('../../../../../../assets/img/common/title.png');
    width: 20px;
    height: 24px;
    float: left;
    margin-top: -3px;
    margin-left: 13px;
    margin-right: 10px;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7a665556